<div class="otp-inputs d-flex justify-items-between gap-2" *ngIf="getCampaign">
    <input
    *ngFor="let index of this.inputs"
    type="tel"
    maxlength="1"
    class="otpInput form-control border-blue-100"
    (input)="onOtpChange($event, index)"
    (focus)="onFocus(index)"
    (blur)="onValidateEmit()"
    (keypress)="onlyNumber($event)"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    #otpInput
    [ngClass]=" 
    {
        'filled border-1 border-blue-100 text-blue-100': validEmptyInput(otp[index]), 
        'error-input': submitted && this.getOtpLength() < this.OTPlength || submitted && !validEmptyInput(otp[index])
    }" />
</div>

<div class="invalid-feedback color-error mt-3" [ngClass]="
{
    'd-block': submitted &&  this.getOtpLength() < this.OTPlength,
    'd-none' : this.getOtpLength() == this.OTPlength
}
">
    Por favor, ingresa el código completo de {{OTPlength}} dígitos.
</div>
